<ng-template let-extraClass="extraClass" #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="'Notification Settings'">
  </tidy-top-nav>
</ng-template>

<ng-container
  *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container
      *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <tidy-row [align]="'center'">
      <tidy-text [body]="'Customize notifications the way you want.'">
      </tidy-text>
    </tidy-row>

    <ng-template #skeletonCard>
      <tidy-row class="no-padding notif-skeleton">
        <tidy-card>
          <tidy-row>
            <ion-skeleton-text [animated]="true" class="skeleton-title"></ion-skeleton-text>
          </tidy-row>
          <div class="skeleton-channel" *ngFor="let row of [1, 2, 3]">
            <ion-skeleton-text [animated]="true" class="skeleton-checkbox"></ion-skeleton-text>
            <ion-skeleton-text [animated]="true" class="skeleton-icon"></ion-skeleton-text>
            <ion-skeleton-text [animated]="true" class="skeleton-label"></ion-skeleton-text>
            <ion-skeleton-text [animated]="true" class="skeleton-chevron"></ion-skeleton-text>
          </div>
        </tidy-card>
      </tidy-row>
    </ng-template>

    <ng-container *ngIf="!loaded && !cameFromWasInvitedByClientOnboarding">
      <ng-container *ngFor="let item of [1, 2, 3, 4, 5, 6]">
        <ng-container *ngTemplateOutlet="skeletonCard"></ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="!loaded && cameFromWasInvitedByClientOnboarding">
      <ng-container *ngTemplateOutlet="skeletonCard"></ng-container>
    </ng-container>

    <ng-container *ngIf="!cameFromWasInvitedByClientOnboarding">
      <tidy-row>
        <form [formGroup]="searchForm" novalidate action="#">
          <tidy-search-input
            formControlName="search"
            [placeholder]="'Search'"
            [icon]="'assets/svg/search-outline.svg'">
          </tidy-search-input>
        </form>
      </tidy-row>

      <tidy-row
        class="save-status"
        [ngClass]="saveState"
        style="margin-top: 1rem">
        <ion-spinner
          *ngIf="saveState === 'saving'"
          name="crescent"
          class="save-status__spinner">
        </ion-spinner>
        <ion-icon
          *ngIf="saveState === 'saved'"
          name="checkmark-circle"
          class="save-status__icon">
        </ion-icon>
        <ion-icon
          *ngIf="saveState === 'error'"
          name="alert-circle"
          class="save-status__icon">
        </ion-icon>
        <tidy-text [body]="savingText"></tidy-text>
      </tidy-row>
    </ng-container>

    <ng-template #channelToggle let-channel="channel" let-notification="notification">
      <div class="channel-header" [class.channel-header--checked]="channel.checked">
        <tidy-checkbox
          (click)="$event.stopPropagation()"
          (checkedChange)="toggleChannel($event, channel, notification)"
          class="custom-checkbox"
          [(checked)]="channel.checked"
          [initValue]="channel.checked"
          [watchOnChange]="true"
          [items]="[{viewValue: '', value: ''}]">
        </tidy-checkbox>
        <tidy-image
          [src]="getChannelIcon(channel.name)"
          [width]="'20px'"
          class="channel-header__icon">
        </tidy-image>
        <tidy-text [body]="channel.name | titlecase"></tidy-text>
      </div>
    </ng-template>

    <ng-container *ngIf="loaded && filteredNotificationsSettings?.length === 0">
      <tidy-row [align]="'center'" class="empty-state">
        <tidy-image
          src="assets/svg/notifications-off-outline.svg"
          [width]="'40px'"
          class="empty-state__icon">
        </tidy-image>
      </tidy-row>
      <tidy-row [align]="'center'">
        <tidy-text [body]="'No notifications match your search.'" class="light"></tidy-text>
      </tidy-row>
    </ng-container>

    <ng-container *ngFor="let notification of filteredNotificationsSettings; let i = index">
      <tidy-row class="no-padding">
        <tidy-card>
          <tidy-row>
            <tidy-text
              [body]="!cameFromWasInvitedByClientOnboarding ? notification.title : 'How do you want to be notified of new job opportunities?'">
            </tidy-text>
            <div *ngIf="notification?.title == 'Message Received'" style="display: flex; align-items: center;">
              <tidy-text
                [helper]="'SMS forwarding enabled'"
                style="margin-right: 5px">
              </tidy-text>
              <tidy-image
                src="assets/img/help-circle-outline.svg"
                class="body-size"
                [matTooltip]="'We forward chats from clients to your SMS (in supported countries)'"
                [matTooltipPosition]="'below'"
                matTooltipClass="menu-item-tooltip below"
                style="opacity: 0.5">
              </tidy-image>
            </div>
          </tidy-row>
          <div class="simple-channels" *ngIf="!notification.allowsTimeRangeConfig">
            <ng-container *ngFor="let channel of notification.channels">
              <div class="channel-row">
                <ng-container
                  *ngTemplateOutlet="channelToggle; context: { channel: channel, notification: notification }">
                </ng-container>
              </div>
            </ng-container>
          </div>

          <ion-accordion-group *ngIf="notification.allowsTimeRangeConfig">
            <ng-container *ngFor="let channel of notification.channels">
              <ion-accordion class="custom-accordion">
                <ion-item slot="header" (click)="openChannelSettings(channel)">
                  <ng-container
                    *ngTemplateOutlet="channelToggle; context: { channel: channel, notification: notification }">
                  </ng-container>
                </ion-item>
                <div slot="content">
                  <ng-container *ngIf="channel.isOpened">
                      <ion-accordion-group>
                        <ng-container
                          *ngFor="let formGrp of channel.timeRangeForms; let timeRangeIndex = index">
                          <ion-accordion [disabled]="!channel.checked">
                            <ion-item
                              slot="header"
                              (click)="onAccordionChange(i, timeRangeIndex)">
                              <tidy-checkbox
                                (click)="$event.stopPropagation()"
                                (checkedChange)="toggleDay($event, notification, channel, formGrp)"
                                class="custom-checkbox"
                                [(checked)]="formGrp.dayForm.controls.checked.value"
                                [initValue]="formGrp.dayForm.controls.checked.value"
                                [watchOnChange]="true"
                                [items]="[{viewValue: '', value: ''}]">
                              </tidy-checkbox>
                              <tidy-text
                                [body]="formGrp.dayForm.controls.day.value  | titlecase"
                                style="margin-left: 10px">
                              </tidy-text>
                            </ion-item>
                            <ng-container
                              *ngIf="expandedIndex === i + '-' + timeRangeIndex">
                              <div class="ion-padding" slot="content">
                                <ng-container
                                  *ngFor="let control of formGrp.timeRangeForm.controls; let last = last; let controlIndex = index">
                                  <tidy-two-column-row
                                    [formGroup]="control"
                                    style="padding-bottom: 1rem">
                                    <tidy-select
                                      style="max-width: 40%; margin: 0"
                                      [icon]="'assets/svg/time-outline.svg'"
                                      [label]="'Earliest'"
                                      [form]="control.controls.start_time"
                                      formControlName="start_time"
                                      errorMessage="Select a valid time"
                                      [submitted]="true"
                                      (optionChange)="updateValidity()"
                                      [items]="timeOpts">
                                    </tidy-select>
                                    <span
                                      style="
                                        align-self: center;
                                        justify-content: space-around;
                                        max-width: 10%;
                                      "
                                      >-</span
                                    >
                                    <tidy-select
                                      style="max-width: 40%; margin-right: 10px"
                                      [icon]="'assets/svg/time-outline.svg'"
                                      [label]="'Latest'"
                                      [form]="control.controls.end_time"
                                      formControlName="end_time"
                                      errorMessage="Select a valid time"
                                      [submitted]="true"
                                      (optionChange)="updateValidity()"
                                      [items]="endTimes(control.controls.start_time.value)">
                                    </tidy-select>
                                    <tidy-image
                                      (action)="removeTimeRange(formGrp.timeRangeForm, controlIndex)"
                                      src="assets/img/trash-icon-outline.svg"
                                      class="icon body-size"
                                      style="
                                        max-width: 16px;
                                        align-self: center;
                                      "></tidy-image>
                                  </tidy-two-column-row>
                                </ng-container>
                                <tidy-row>
                                  <tidy-text
                                    [body]="'+ Add Time Restriction'"
                                    (action)="addTimeRange(formGrp.timeRangeForm)"
                                    class="link">
                                  </tidy-text>
                                </tidy-row>
                              </div>
                            </ng-container>
                          </ion-accordion>
                        </ng-container>
                      </ion-accordion-group>
                    </ng-container>
                </div>
              </ion-accordion>
            </ng-container>
          </ion-accordion-group>
        </tidy-card>
      </tidy-row>
    </ng-container>

    <tidy-button
      *ngIf="cameFromWasInvitedByClientOnboarding"
      [text]="'Save Settings'"
      class="primary"
      [action]="submitSettings.bind(this)">
    </tidy-button>

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
